import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { getPermissions } from "../../_helpers/authorize";
import { DOCTYPE } from "../../_constants/docTypeConstants";

// UI components
import adrTitleBarMenuV3 from "../_titleBarMenus/adrTitleBarMenuV3";

// Child components
import AdrHeaderV3 from "./AdrHeaderV3";
import AdrWorkPerformedV3 from "./AdrWorkPerformedV3";
import AdrLaborSetV3 from "./AdrLaborSetV3";
import AdrEquipmentSetV3 from "./AdrEquipmentSetV3";
import AdrGeneralCommentsV3 from "./AdrGeneralCommentsV3";
import AdrFileUploadModalV3 from "./AdrFileUploadModalV3";
import AdrSaveSuccessModalV3 from "./AdrSaveSuccessModalV3";
import AdrReviewV3 from "./AdrReviewV3/AdrReviewV3";
import AdrTentativeAgreementsV3 from "./AdrTentativeAgreementsV3";

// Common components
import TitleBar from "../_common/TitleBar";
import AlertModal from "../_common/AlertModal";

import mainTabActions from "../../_actions/mainTabActions";

// Stylesheets
import "./styles/adr.css";
// import "react-block-ui/style.css";
import "loaders.css/loaders.min.css";
import { actionScripts } from "../../_helpers/actionScripts";
import adrActions from "../../_actions/adrActions";
import { ADR_EDIT } from "../../_constants/actionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import pdfActions from "../../_actions/pdfActions";
import cem4601PdfActions from "../../_actions/cem4601PdfActions";
import memoizeOne from "memoize-one";
import AdrSubmitSignatureModalV3 from "./AdrSubmitSignatureModalV3";
import AlertBox from "../_common/AlertBox";

class AdrMainV3 extends Component {
  state = {
    // Remember to override if necessary
    status: {
      isNew: true,
      isChanged: false,
      isReadOnly: true,
      userIsAuthor: false,
      userIsReviewer: false,
    },
    showModal_signature: false,
    showAlert_saveWarn: false,
    showAlert_saveSuccess: false,
    showAlert_delete: false,
    saveType: null,
    selectedMode: "edit",
    submitting: false,
    saving: false,
  };

  componentDidMount() {
    const { dispatch, adr, user, tab, fetching, projectId } = this.props;

    // props.adr MAY be available at CDM during copy, so below condition must handle.
    // CDU has the same routine in case props.adr becomes available then.
    if (user && adr) {
      const isNew = adr.assistantDailyReportId === 0;

      // For new or copied Adr, adr.authorUserId and adr.reviewerUserId are
      // set to 0, so userIsAuthor and userIsReviewer will both be false,
      // but only initially - author info will be updated for this case immediately
      // after the below setState.
      const userIsAuthor = adr.authorUserId === user.userId;

      // userIsReviewer = true if adr has a non-null reviewerUserId that matches the current
      // userId
      const userIsReviewer =
        adr && adr.isInReview && adr.reviewerUserId && adr.reviewerUserId === user.userId;
      const userHasReviewRights =
        adr && (adr.potentialReviewerUserIds || []).includes(user.userId);

      this.setState({
        status: {
          ...this.state.status,
          isNew,
          isReadOnly: fetching || !userIsAuthor || adr.isApproved || adr.isSubmitted,
          userIsAuthor,
          userIsReviewer,
        },
        selectedMode:
          (userIsReviewer || userHasReviewRights) && adr.isSubmitted ? "review" : "edit",
      });

      // For new or copied Adr, the currently logged-in user is the author.
      if (isNew || adr.isCopy) {
        const headerFields = {
          authorUserId: user.userId,
          authorEmployeeNo: user.employeeNo,
          authorFirstName: user.firstName,
          authorLastName: user.lastName,
          authorFullName: user.fullName,
        };
        dispatch({ type: ADR_EDIT.HEADER.UPDATE, tabId: tab.tabId, headerFields });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isChanged } = this.state.status;
    const { tab, dispatch, user, adr, fetching } = this.props;

    // When adr is loaded from an async process (null in prevProps, not-null
    // in this.props), update the status:
    if (!prevProps.adr && adr) {
      const isNew = adr.assistantDailyReportId === 0;

      // For new or copied Adr, adr.authorUserId and adr.reviewerUserId are
      // set to 0, so userIsAuthor and userIsReviewer will both be false,
      // but only initially - author info will be updated for this case immediately
      // after the below setState.
      const userIsAuthor = adr.authorUserId === user.userId;

      // userIsReviewer = true if adr has a non-null reviewerUserId that matches the current
      // userId
      const userIsReviewer =
        adr && adr.isInReview && adr.reviewerUserId && adr.reviewerUserId === user.userId;
      const userHasReviewRights =
        adr && (adr.potentialReviewerUserIds || []).includes(user.userId);

      this.setState({
        status: {
          ...this.state.status,
          isNew,
          isReadOnly: fetching || !userIsAuthor || adr.isApproved || adr.isSubmitted,
          userIsAuthor,
          userIsReviewer,
        },
        selectedMode:
          (userIsReviewer || userHasReviewRights) && adr.isSubmitted ? "review" : "edit",
      });

      // For new or copied Adr, the currently logged-in user is the author.
      if (isNew || adr.isCopy) {
        const headerFields = {
          authorUserId: user.userId,
          authorEmployeeNo: user.employeeNo,
          authorFirstName: user.firstName,
          authorLastName: user.lastName,
          authorFullName: user.fullName,
        };
        dispatch({ type: ADR_EDIT.HEADER.UPDATE, tabId: tab.tabId, headerFields });
      }
    }

    // For all other updates to Adr in-session:
    if (prevProps.adr && adr) {
      let mustUpdateState = false;

      // When author info is updated: (One trigger is from CDM above for new or copied Adr.)
      if (prevProps.adr.authorUserId !== adr.authorUserId) mustUpdateState = true;

      // When a new DR is saved:
      if (prevState.status.isNew && adr.assistantDailyReportId !== 0)
        mustUpdateState = true;

      // When any readOnly factors are updated:
      if (
        prevProps.fetching !== fetching ||
        prevProps.adr.isApproved !== adr.isApproved ||
        prevProps.adr.isSubmitted !== adr.isSubmitted ||
        prevProps.adr.authorUserId !== adr.authorUserId
      )
        mustUpdateState = true;

      if (mustUpdateState) {
        const userIsAuthor = adr.authorUserId === user.userId;

        // userIsReviewer = true if adr has a non-null reviewerUserId that matches the current
        // userId
        const userIsReviewer =
          adr &&
          adr.isInReview &&
          adr.reviewerUserId &&
          adr.reviewerUserId === user.userId;

        this.setState({
          status: {
            ...this.state.status,
            isNew: adr.assistantDailyReportId === 0,
            isReadOnly: fetching || !userIsAuthor || adr.isApproved || adr.isSubmitted,
            userIsAuthor,
            userIsReviewer,
          },
        });
      }
    }

    // // When author info is updated: (One trigger is from CDM above for new or copied Adr.)
    // if (prevProps.adr && adr && !prevProps.adr.authorUserId && adr.authorUserId) {
    //   const userIsAuthor = adr.authorUserId === user.userId;
    //   const userIsReviewer = adr.reviewerUserId === user.userId;
    //   this.setState({
    //     status: {
    //       ...this.state.status,
    //       isReadOnly: fetching || !userIsAuthor || adr.isApproved || adr.isSubmitted,
    //       userIsAuthor,
    //       userIsReviewer,
    //     },
    //   });
    // }

    // // When any readOnly factors are updated, ensure isReadOnly is updated:
    // if (
    //   prevProps.adr &&
    //   (prevProps.fetching !== fetching ||
    //     prevProps.adr.isApproved !== adr.isApproved ||
    //     prevProps.adr.isSubmitted !== adr.isSubmitted ||
    //     prevProps.adr.authorUserId !== adr.authorUserId)
    // )
    //   this.setState({
    //     status: {
    //       ...this.state.status,
    //       isReadOnly:
    //         fetching ||
    //         adr.authorUserId !== user.userId ||
    //         adr.isApproved ||
    //         adr.isSubmitted,
    //     },
    //   });

    // When Adr is changed (from markAdrDirty):
    if (prevState.status.isChanged !== isChanged && isChanged)
      dispatch(mainTabActions.markTabContentDirty(tab.tabId));
  }

  /**
   * Event handlers for TitleBar in ADR
   * @param {string} action - Triggered action type
   */
  handleTitleBarAction = (action) => async () => {
    const { tab, adr, dispatch, user, appSettings } = this.props;
    const { status } = this.state;
    switch (action) {
      case "toggleEditMode":
        // Must save any review changes made (corr. comments or clar. comments)
        // when adr.isInReview. For other states (isDraft/isRejected, etc.),
        // do nothing - the reviewer cannot perform any actions in these states anyway.
        if (!adr) break;
        if (adr.isInReview) {
          dispatch(adrActions.saveReview(tab.tabId)).then(() =>
            this.setState({ selectedMode: "edit" }, () =>
              actionScripts.REFETCH_ADR_IN_TAB.run(
                adr.projectId,
                adr.assistantDailyReportId,
                tab.tabId
              )
            )
          );
        } else this.setState({ selectedMode: "edit" });
        break;
      case "toggleReviewMode": {
        // When toggling from a DR in draft/rejected state, any unsaved changes must be
        // saved before toggling review mode, to ensure all correction comments'
        // field references are intact.
        if (!adr) break;
        if (adr.isDraft || adr.isRejected) {
          dispatch(adrActions.clearTempFilePaths(tab.tabId));
          dispatch(adrActions.save(tab.tabId)).then(() =>
            this.setState({ selectedMode: "review" }, () =>
              actionScripts.REFETCH_ADR_IN_TAB.run(
                adr.projectId,
                // By this point, the 'adr' reference is already stale since
                // update has been made. Use a fresh this.props.adr instead.
                this.props.adr.assistantDailyReportId,
                tab.tabId
              )
            )
          );
        } else this.setState({ selectedMode: "review" });
        break;
      }
      case "printPdf":
        if (!adr) break;

        // If adr is in a modifiable state, save prior to generating its PDF.
        // (PdfService will pull adr from database so changes need to be committed.)
        if (adr.isDraft || adr.isRejected) {
          dispatch(adrActions.clearTempFilePaths(tab.tabId));
          await dispatch(adrActions.save(tab.tabId, status.isNew));
        }

        if (appSettings.useClientSidePDFGeneration)
          actionScripts.PRINT_ADR_ON_CLIENT.run(tab.tabId, true);
        else {
          // First check if the PdfService is running. If not, run it client-side.
          const serviceOk = await dispatch(pdfActions.testService());
          if (serviceOk) {
            // Send request to the server. If it fails, attempt on client-sie.
            try {
              await dispatch(cem4601PdfActions.requestPdf(tab.tabId));
            } catch (e) {
              console.error("Attempting PDF creation on client...", e);
              actionScripts.PRINT_ADR_ON_CLIENT.run(tab.tabId, true);
            }
          } else actionScripts.PRINT_ADR_ON_CLIENT.run(tab.tabId, true);
        }
        break;
      case "savePdf":
        actionScripts.PRINT_ADR_ON_CLIENT.run(tab.tabId, false);
        break;
      case "amend": {
        if (
          status.userIsAuthor ||
          (adr && (adr.potentialReviewerUserIds || []).includes(user.userId))
        ) {
          // If approved, isRejected and isDraft are automatically false.
          if (!adr.isApproved) alert("Only previously accepted assistant daily reports can be amended.");
          else
            actionScripts.AMEND_ADR.run(
              adr.projectId,
              adr.assistantDailyReportId,
              user.userId
            );
        } else
          alert(
            "Only the original author or those with review privileges can make amendments."
          );
        break;
      }
      case "saveDraft": {
        if (!adr) break;
        if (!adr.isSubmitted && !adr.isApproved && !adr.isRejected)
          this.save("saveDraft");
        else alert("This daily report can no longer be saved as a draft.");
        break;
      }
      case "copy":
        if (!adr) break;
        actionScripts.COPY_ADR.run(tab.tabId, tab.projectId, user.userId);
        break;
      case "delete":
        if (!adr) break;
        this.toggleAlert_delete();
        break;
      case "submit": {
        if (!adr) break;
        if (status.userIsAuthor) {
          if (!adr.isSubmitted && !adr.isApproved) this.save("saveSubmit");
          else
            alert(
              "This daily report has already been submitted or approved, and cannot be submitted again."
            );
        } else alert("You are not the author of this daily report.");
        break;
      }
      case "close":
        this.close();
        break;
      default:
        break;
    }
  };

  markAdrDirty = () => {
    const { status } = this.state;
    if (!status.isChanged) this.setState({ status: { ...status, isChanged: true } });
  };

  markAdrClean = () =>
    this.setState({ status: { ...this.state.status, isChanged: false } });

  submit = async () => {
    const { dispatch, tab, adr, user } = this.props;

    dispatch(adrActions.clearTempFilePaths(tab.tabId));

    const res = await dispatch(adrActions.submit(tab.tabId));

    if (res) {
      if (!user.userPreferences?.userProfile?.doNotPromptForSignature)
        this.toggleModal_signature();
      else {
        await dispatch(adrActions.markAsSigned(tab.tabId));

        // Create PDF for submit. Do not await this.
        dispatch(cem4601PdfActions.createPdfForSubmit(adr.assistantDailyReportId));
        this.toggleAlert_saveSuccess("saveSubmit");
      }
    }

    this.setState({ submitting: false, saving: false });
  };

  save = async () => {
    const { dispatch, tab } = this.props;

    dispatch(adrActions.clearTempFilePaths(tab.tabId));

    const res = await dispatch(adrActions.save(tab.tabId));

    if (res) this.toggleAlert_saveSuccess("saveDraft");

    this.setState({ submitting: false, saving: false });
  };

  close = () => {
    const { dispatch, tab } = this.props;

    if (tab.contentIsModified) this.toggleAlert_saveWarn();
    else dispatch(mainTabActions.closeTab(tab.tabId));
  };

  /**
   * Render the file upload modal for locWp and comment attachments.
   * Also performs some pre-op required to set file context data for use by
   * the modal. Data provided through FileUploadContext are used to generate
   * meaningful filenames for all files uploaded through the modal session.
   * @param {import("../../_typedefs/adrV3TypeDefs").FileUploadContext} fc
   */
  fileUploadModal = (fc) => {
    const { tab, user, jobStamp, adr } = this.props;

    // reportStartDate is a js Date()
    const reportDate = adr.reportStartDate
      ? moment(adr.reportStartDate).format()
      : moment().format();

    // Create placeholder for subContext, as its value will be determined based
    // on whether the context is locWp or comments. subContext provides:
    // 1) workPerformed (item/CCO/PI) and location name for locWp, and
    // 2) comment row # for comments.
    let subContext = ""; // NO LONGER USED, SINCE ALL ATTACHMENTS ARE NOW SAVED AT THE SAME LEVEL AS THE PDF FOR ADR

    // // subContext for locWp attachments:
    // if (fc.wpTabId != null && fc.locationId != null) {
    //   const wp = adr.workPerformedClient[fc.wpTabId];
    //   const loc = (projLocationList || []).find((l) => l.locationId === fc.locationId);
    //   const locName = loc ? loc.name : "(locNameUndefined)";
    //   subContext = (wp.wpShortId + "_" + locName).replace(/\s/g, ""); // Remove spaces for URL
    // }
    // // subContext for comment attachments:
    // else if (fc.gcClientId != null) subContext = "Comment_" + fc.gcClientId;

    // Package all context data
    const fileUploadContext = {
      ...fc,
      fullEA: jobStamp ? jobStamp.fullEA : "",
      reportDate,
      userEmployeeNo: user.employeeNo,
      subContext,
    };

    // Return the modal component
    return (
      <AdrFileUploadModalV3
        tabId={tab.tabId}
        fileUploadContext={fileUploadContext}
        markAdrDirty={this.markAdrDirty}
        status={this.state.status}
      />
    );
  };

  handleAlert_saveSuccess = (selectedCloseType) => {
    const { dispatch, tab, adr, user } = this.props;
    switch (selectedCloseType) {
      case "closeAdr": {
        dispatch(mainTabActions.closeTab(tab.tabId));
        break;
      }
      case "copyAdr": {
        actionScripts.COPY_ADR.run(tab.tabId, tab.projectId, user.userId);
        break;
      }
      case "keepEditing": {
        // Update state.isNew to false:
        this.setState({
          status: { ...this.state.status, isNew: false, isChanged: false },
        });
        // Re-fetch and re-initialize adrClient.
        // Note: This actionScript is async.
        actionScripts.REFETCH_ADR_IN_TAB.run(
          tab.projectId,
          adr.assistantDailyReportId,
          tab.tabId
        );
        break;
      }
      default:
        break;
    }
    this.toggleAlert_saveSuccess();
  };

  handleAlert_saveWarn = (alertAction) => (e) => {
    const { dispatch, tab } = this.props;
    e.preventDefault();
    if (alertAction === "accept") dispatch(mainTabActions.closeTab(tab.tabId));
    this.toggleAlert_saveWarn();
  };

  handleAlert_delete = (alertAction) => (e) => {
    const { tab, adr } = this.props;
    e.preventDefault();
    if (alertAction === "accept")
      actionScripts.DELETE_ADR.run(tab.projectId, adr.assistantDailyReportId, tab.tabId);
    this.toggleAlert_delete();
  };

  toggleModal_signature = () =>
    this.setState({ showModal_signature: !this.state.showModal_signature });

  toggleAlert_saveSuccess = (saveType = null) => {
    window.scrollTo(0, 0);
    this.setState({
      showAlert_saveSuccess: !this.state.showAlert_saveSuccess,
      saveType,
    });
  };

  toggleAlert_saveWarn = () =>
    this.setState({ showAlert_saveWarn: !this.state.showAlert_saveWarn });

  toggleAlert_delete = () =>
    this.setState({ showAlert_delete: !this.state.showAlert_delete });

  handleClick_submit = (e) => {
    e.preventDefault();
    this.setState({ submitting: true }, () => this.submit());
  };

  handleClick_save = (e) => {
    e.preventDefault();
    this.setState({ saving: true }, () => this.save());
  };

  handleClick_close = (e) => {
    e.preventDefault();
    this.close();
  };

  memoizedTaStillPending = memoizeOne((tas) => (tas || []).some((ta) => !ta.isLocked));

  render() {
    const { tab, adr, fetching, jobStamp, permissions, user, workPerformedClient } = this.props;
    const {
      status,
      selectedMode,
      showModal_signature,
      showAlert_saveSuccess,
      showAlert_saveWarn,
      showAlert_delete,
      saveType,
      submitting,
      saving,
    } = this.state;

    const titleTextBase = "Daily Report ";
    const taStillPending =
      adr && adr.tentativeAgreements
        ? this.memoizedTaStillPending(adr.tentativeAgreements)
        : true;

    return (
      <React.Fragment>
        <TitleBar
          titleText={`${titleTextBase} ${
            selectedMode === "edit" ? "(Edit Mode)" : "(Review Mode)"
          }`}
          menu={adrTitleBarMenuV3}
          toggleValue={selectedMode}
          disabledActions={{
            toggleReviewMode: fetching,
            printPdf: fetching,
            amend:
              fetching ||
              !adr ||
              !adr.isApproved ||
              adr.isSuperseded ||
              !status.userIsAuthor,
            saveDraft: fetching || !adr || status.isReadOnly,
            copy: fetching,
          }}
          handleTitleBarAction={this.handleTitleBarAction}
        />
        {selectedMode === "edit" ? (
          <React.Fragment>
            <AdrHeaderV3
              status={status}
              tabId={tab.tabId}
              fullEA={jobStamp ? jobStamp.fullEA : ""}
              markAdrDirty={this.markAdrDirty}
            />
            {adr && !adr.isCem4501 && (
              <React.Fragment>
                <AdrWorkPerformedV3
                  status={status}
                  tabId={tab.tabId}
                  projectId={tab.projectId}
                  markAdrDirty={this.markAdrDirty}
                  fileUploadModal={this.fileUploadModal}
                />
                {Object.keys(workPerformedClient).length > 0 && (
                <>
                 <AdrLaborSetV3
                  status={status}
                  fetching={fetching}
                  tabId={tab.tabId}
                  projectId={tab.projectId}
                  markAdrDirty={this.markAdrDirty}
                  />
                 <AdrEquipmentSetV3
                  status={status}
                  fetching={fetching}
                  tabId={tab.tabId}
                  projectId={tab.projectId}
                  markAdrDirty={this.markAdrDirty}
                  />
                </>
                )}
              </React.Fragment>
            )}
            <AdrGeneralCommentsV3
              status={status}
              tabId={tab.tabId}
              projectId={tab.projectId}
              markAdrDirty={this.markAdrDirty}
              fileUploadModal={this.fileUploadModal}
            />
            {adr && !adr.isCem4501 && (
              <AdrTentativeAgreementsV3
                status={status}
                tabId={tab.tabId}
                projectId={tab.projectId}
                markAdrDirty={this.markAdrDirty}
                markAdrClean={this.markAdrClean}
              />
            )}
            <div className="card mb-2 mx-2 bg-lightgray">
              <div className="card-body">
                <div className="d-flex flex-row-reverse">
                  <div className="">
                    <button
                      className="btn btn-primary mr-3"
                      type="button"
                      id="saveSubmit"
                      name="saveSubmit"
                      onClick={this.handleClick_submit}
                      disabled={
                        !adr ||
                        status.isReadOnly ||
                        submitting ||
                        saving ||
                        taStillPending
                      }
                    >
                      {submitting && (
                        <span className="mr-2 mt-1">
                          <FontAwesomeIcon
                            icon="spinner"
                            className="loading-spinner"
                            style={{ color: "white" }}
                          />
                        </span>
                      )}
                      <b>Sign & Submit</b>
                      {taStillPending && " (TA(s) still pending)"}
                    </button>
                    <span className="mr-3 submit-separator">|</span>
                    <button
                      className="btn btn-secondary mr-2"
                      type="button"
                      id="saveDraft"
                      name="saveDraft"
                      onClick={this.handleClick_save}
                      disabled={!adr || status.isReadOnly || submitting || saving}
                    >
                      {saving && (
                        <span className="mr-2 mt-1">
                          <FontAwesomeIcon
                            icon="spinner"
                            className="loading-spinner"
                            style={{ color: "white" }}
                          />
                        </span>
                      )}
                      {!adr || adr.isRejected ? "Save" : "Save Draft"}
                    </button>
                    <button
                      className="btn btn-danger mr-2"
                      type="button"
                      id="close"
                      name="close"
                      onClick={this.handleClick_close}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex flex-row mt-2 mx-2">
              <AlertBox
                color="info"
                icon="info-circle"
                title="Electronic Signature Disclosure"
              >
                When you submit this Daily Report with your signature, you are verifying
                that the statements and information provided are true and correct, and
                attest to the validity of all contents within this electronic submission
                at the time of submit.
              </AlertBox>
            </div>
            {showModal_signature && (
              <AdrSubmitSignatureModalV3
                showModal={showModal_signature}
                toggleModal={this.toggleModal_signature}
                assistantDailyReportId={adr.assistantDailyReportId}
                authorUserId={adr.authorUserId}
                tabId={tab.tabId}
                onSign={() => this.toggleAlert_saveSuccess("saveSubmit")}
              />
            )}
            {showAlert_saveSuccess && (
              <AdrSaveSuccessModalV3
                showAlert_saveSuccess={showAlert_saveSuccess}
                toggleAlert_saveSuccess={this.toggleAlert_saveSuccess}
                handleAlert_saveSuccess={this.handleAlert_saveSuccess}
                saveType={saveType}
              />
            )}
            {showAlert_saveWarn && (
              <AlertModal
                alertTitle="Unsaved Changes"
                alertTitleClass="bg-warning"
                alertTitleIcon="exclamation-triangle"
                alertText={
                  `There are unsaved changes.\n` +
                  `Any unsaved data will be lost after closing this tab.`
                }
                acceptCaption={"Close"}
                acceptClass={"danger"}
                provideReject={true}
                rejectCaption={"Keep Open"}
                rejectClass={"secondary"}
                handleAlertAction={this.handleAlert_saveWarn}
                toggleAlertModal={this.toggleAlert_saveWarn}
                showAlertModal={showAlert_saveWarn}
              />
            )}
            {showAlert_delete && (
              <AlertModal
                alertTitle="Delete"
                alertTitleClass="bg-warning"
                alertTitleIcon="exclamation-triangle"
                alertText={`${
                  !adr.isDraft && "This Daily Report is already being reviewed.\n"
                }Are you sure you wish to delete?`}
                acceptCaption={"Yes"}
                acceptClass={"danger"}
                provideReject={true}
                rejectCaption={"No"}
                rejectClass={"secondary"}
                handleAlertAction={this.handleAlert_delete}
                toggleAlertModal={this.toggleAlert_delete}
                showAlertModal={showAlert_delete}
              />
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <AdrReviewV3
              tabId={tab.tabId}
              projectId={tab.projectId}
              status={status}
              userIsReviewer={status.userIsReviewer}
              markAdrDirty={this.markAdrDirty}
              markAdrClean={this.markAdrClean}
              permissions={permissions}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  appSettings: state.appSettings,
  user: state.authentication.user,
  adr: state.adr.openAdrs[ownProps.tab.tabId] || null,
  jobStamp: state.projects.jobStamps[ownProps.tab.projectId] || null,
  projLocationList: state.locations.projLocationLists[ownProps.tab.projectId] || null,
  permissions: getPermissions({
    user: state.authentication.user,
    docType: DOCTYPE.ADR,
    projectId: ownProps.tab.projectId,
    creatorId: null,
  }),
  fetching:
    state.adr.fetching ||
    state.adr.fetchingPreview ||
    state.locations.fetching ||
    state.keywords.fetching ||
    state.bidItems.fetching ||
    state.ccos.fetching ||
    state.contractors.fetching ||
    state.labors.fetching ||
    state.equipment.fetching ||
    state.projects.fetching,
  workPerformedClient: state.adr?.openAdrs?.[ownProps.tab?.tabId]?.workPerformedClient ?? {}
});

export default connect(mapStateToProps)(AdrMainV3);
